exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_2kWFKnFV{width:100%;height:250px;margin:0 auto;position:relative;-ms-flex-pack:center;justify-content:center}.container_2kWFKnFV,.container_2kWFKnFV ul li{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.container_2kWFKnFV ul li{border-bottom:1px solid #aeb0b3;box-sizing:border-box;color:#aeb0b3;padding:0 10px}.container_2kWFKnFV ul li:last-child{border:none}.container_2kWFKnFV ul li span{padding-right:30px}.container_2kWFKnFV ul li div{-ms-flex-positive:1;flex-grow:1;text-align:right;font-weight:700;color:#86888c}.chart_OHVIjCrL{position:relative;z-index:2;width:250px}", ""]);

// exports
exports.locals = {
	"container": "container_2kWFKnFV",
	"chart": "chart_OHVIjCrL"
};